import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { IndexSignature } from 'utils/praxTypes';
import { clearAccessToken, getAccessToken, getAuthorizationHeaderValue, getLanguage } from './browserStorageServices';

axios.defaults.paramsSerializer = (object: IndexSignature) => {

  let queryParams: string = "";
  Object.keys(object).forEach((key, index) => {
    if (index == 0) {
      queryParams += `${key}=${encodeURIComponent(object[key])}`;
    } else {
      queryParams += `&${key}=${encodeURIComponent(object[key])}`;
    }
  });

  return queryParams;
};

const authenticationInterceptor = (config: AxiosRequestConfig) => {
  const accessToken = getAccessToken();
  if (accessToken) {
    const authValue = getAuthorizationHeaderValue(accessToken);
    config.headers['Authorization'] = authValue;
    config.headers['ConvId'] = authValue ? authValue.substring(Math.max(0, authValue.length - 15)) : "";
  }

  config.headers["Accept-Language"] = getLanguage();

  return config;
};

axios.interceptors.request.use(authenticationInterceptor);

function globalErrorHandler(error: AxiosError) {
  if (error.response && error.response.status === 401) {
    clearAccessToken();
  }
  return Promise.reject(error);
}

axios.interceptors.response.use(response => response, globalErrorHandler);

export default axios;
